import { ContextualInfoButton } from "@/components/buttons/ContextualInfoButton";
import { ADAPTATION_TERM_COLORS, adaptationTermsConfig, adaptationTypeValues, DELTA_COLOR, type AdaptationTerms, type AdaptationType, type TermDisplayConfig } from "@/types/adaptation";
import { Badge, Tag } from "antd";
import { useTranslation } from "react-i18next";
type AdaptationTypeTagProps = TermDisplayConfig & {
  text: string;
};
const AdaptationTag = ({
  type,
  solid = false,
  closable = false,
  onClose
}: {
  solid?: boolean;
  type: AdaptationTerms | "compare";
  closable?: boolean;
  onClose?: (event: React.MouseEvent<HTMLElement>) => void;
}) => {
  const {
    t
  } = useTranslation("terms");
  const termLabel = (term: AdaptationTerms) => t(adaptationTypeValues.includes(term as AdaptationType) ? `adaptationTypes.${term}` : term, {
    defaultValue: term
  });
  const config = type in adaptationTermsConfig ? {
    ...adaptationTermsConfig[type as keyof typeof adaptationTermsConfig],
    text: termLabel(type as AdaptationTerms)
  } : {
    color: type === "compare" ? DELTA_COLOR : ADAPTATION_TERM_COLORS[type as AdaptationType],
    text: type === "compare" ? "Compare" : termLabel(type)
  };
  const renderTag = ({
    color,
    text,
    contextId
  }: AdaptationTypeTagProps) => <Tag style={{
    color,
    backgroundColor: solid ? `${color}2d` : `${color}1c`
  }} closable={closable} onClose={onClose} styles={{
    close: {
      color
    }
  }} className={`m-0 inline-flex h-[22px] items-center gap-1 border-none px-[6px] ${solid ? "shadow-md backdrop-blur-lg" : ""}`} data-sentry-element="Tag" data-sentry-component="renderTag" data-sentry-source-file="AdaptationTag.tsx">
      <Badge color={color} data-sentry-element="Badge" data-sentry-source-file="AdaptationTag.tsx" />
      <span className="text-[12px] font-normal tracking-wide">{text}</span>
      {contextId && <ContextualInfoButton size="small" className="!text-[12px]" style={{
      color,
      marginTop: "unset"
    }} id={contextId} />}
    </Tag>;
  return renderTag(config as AdaptationTypeTagProps);
};
export default AdaptationTag;